<template>
  <div>
    <h5 class="card-title">基本信息</h5>
    <h6 class="card-subtitle text-muted">显示机构的基础信息</h6><hr>
    <form>
      <div class="form-group row">
        <label for="orgName" class="col-sm-2 col-form-label">机构名称</label>
        <div class="col-sm-10">
          <input type="text" readonly class="form-control-plaintext" id="orgName" v-model="orgInfo.name">
        </div>
      </div>
      <div class="form-group row">
        <label for="orgBoss" class="col-sm-2 col-form-label">机构负责人</label>
        <div class="col-sm-10">
          <input type="text" readonly class="form-control-plaintext" id="orgBoss" v-model="orgInfo.orgBoss">
        </div>
      </div>
      <div class="form-group row">
        <label for="orgBossMobile" class="col-sm-2 col-form-label">联系电话</label>
        <div class="col-sm-10">
          <input type="text" readonly class="form-control-plaintext" id="orgBossMobile" v-model="orgInfo.orgBossMobile">
        </div>
      </div>
      <div class="form-group row">
        <label for="createTime" class="col-sm-2 col-form-label">创建时间</label>
        <div class="col-sm-10">
          <input type="text" readonly class="form-control-plaintext" id="createTime" v-model="orgInfo.createTime">
        </div>
      </div>
      <div class="form-group row">
        <label for="lastUpdateTime" class="col-sm-2 col-form-label">最后更新时间</label>
        <div class="col-sm-10">
          <input type="text" readonly class="form-control-plaintext" id="lastUpdateTime" v-model="orgInfo.lastUpdateTime">
        </div>
      </div>

    </form>

  </div>
</template>

<script>
import * as orgFacade from "../../../api/org-facade.js";


export default {
  // validations:
  props:{
    orgId: String,
  },
  data() {
    return {
      orgInfo: {}
    };
  },
  watch:{
  },
  created() {
  },
  mounted() {
    this.getOrgInfo()
  },
  methods: {
    // 获取当前用户的机构信息
    getOrgInfo(){
      this.pageLoading = true;
      if(this.orgId == null){
        orgFacade
          .getUserOrgInfo()
          .then(res => {
            this.pageLoading = false;
            this.orgInfo = res;
          })
          .catch(err => {
            console.log("err", err);
            this.pageLoading = false;
          });
      }else{
        orgFacade
          .getOrgInfo(this.orgId)
          .then(res => {
            this.pageLoading = false;
            this.orgInfo = res;
          })
          .catch(err => {
            console.log("err", err);
            this.pageLoading = false;
          });

      }
    },

  }
};
</script>

<style >
</style>
